const useGetUserDetails = () => {
  const user = localStorage.getItem("userData");
  const userDetails = JSON.parse(user);

  return {
    userDetails: userDetails,
  };
};

export default useGetUserDetails;
